var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dir',{staticClass:"privacy-page"},[_c('h1',[_vm._v("Политика конфиденциальности в процессе обновления.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }